const USER_DASHBOARD_API = {
	LEARNING_PATH_ASSIGNMENTS: '/learning-path-assignments',
	ACTIVITY_ASSIGNMENTS: '/activity-assignments',
	ACTIVITY_CATEGORIES: '/activity-categories'
};

export default USER_DASHBOARD_API;
